import type { accessCredentialsVerificationIdType } from 'BreetHelpers';
import * as yup from 'yup';

export interface IDialogEditDeveloperIpAddressChildProps {
	title?: string;
	description?: string;
	noModal?: boolean;
	ipAddress?: string;
	label: string;
	cta: string;
	disabled?: boolean;
	tip?: string;
	/** Render without the outer developer card + title header, e.g. when nested inside an Accordion. */
	noCard?: boolean;
	accessCredentialsVerificationId: accessCredentialsVerificationIdType;
}

export const IPAddressSchema = yup.object({
	ipAddress: yup
		.string()
		.required('IP address is required')
		.test('valid-ip', 'Please enter a valid IP address (IPv4)', (value) => {
			if (!value) return false;
			const pattern = /^(?:(?:25[0-5]|2[0-4]\d|[01]?\d?\d)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d?\d)$/;
			return pattern.test(value);
		}),
});

export type IPAddressSchemaType = yup.InferType<typeof IPAddressSchema>;

export type IPSTAGE = 'ip-address' | 'otp-verification';
